var TowerControlModule = /** @class */ (function () {
    function TowerControlModule() {
    }
    return TowerControlModule;
}());
export { TowerControlModule };
